import { atom } from "recoil";
import { v4 as uuidv4 } from "uuid";

export const initItem = () => {
  const id = uuidv4();
  return {
    id,
    key: id,
    q: { content: [], required: true, type: "text" },
    option: { content: "" },
    answers: [],
  };
};
export const quizInfoTitle = atom({
  key: "quiz/info/title",
  default: "",
});

export const quizInfoContents = atom({
  key: "quiz/info/contents",
  default: [],
});

export const quizList = atom({
  key: "quiz/info/list",
  default: [{ ...initItem() }],
});

export const quizFocusIndex = atom({
  key: "quiz/info/index",
  default: 0,
});

export const quizResponseList = atom({
  key: "quiz/response/list",
  default: [],
});

export const quizResponseTime = atom({
  key: "quiz/response/time",
  default: 0,
});

export const quizScoringResult = atom({
  key: "quiz/scoring/item",
  default: {
    date: null,
    results: [],
    score: 0,
    time: "00:00:00",
  },
});
